import {useQueryParams} from '@aboutyou/router';

export const SEARCH_TERM_PARAM = 'term';

export const useSearchTerm = () => {
  const queryParams = useQueryParams();
  const term = queryParams.get(SEARCH_TERM_PARAM) ?? '';

  return term;
};
